function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#3A4164;stroke:#3A4164;stroke-linejoin:round;stroke-miterlimit:1.4142;}\n\t.st1{fill:#3A4164;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#3A4164;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F88E9F;}\n\t.st4{fill:#F88E9F;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ai",
  transform: "matrix(0.640466,0,0,0.640466,172.308,603.555)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.01682,0,0,1.01682,358.777,-137.695)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M-433.83-791.26c26.29,0.25,50.21,22.76,50.47,50.47c0.14,44.34,0.14,88.68,0,133.01 c-0.25,26.29-22.76,50.21-50.47,50.47c-44.34,0.14-88.68,0.14-133.01,0c-26.34-0.25-50.21-23.09-50.47-50.47 c-0.14-44.34-0.14-88.68,0-133.01c0.25-26.34,23.09-50.21,50.47-50.47C-522.51-791.4-478.17-791.4-433.83-791.26z M-566.5-775.39 c-18.09,0.06-34.77,15.51-34.95,34.71c-0.13,44.34-0.4,88.69,0,133.03c0.28,17.91,15.61,34.19,34.49,34.49 c44.42,0.41,88.83,0.41,133.25,0c17.92-0.28,34.2-15.67,34.49-34.49c0.44-44.42,0.44-88.83,0-133.25 c-0.27-17.87-15.61-34.19-34.49-34.49C-477.98-775.79-522.24-775.39-566.5-775.39z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,166.254,-342.232)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M-257.79-424.95h-17.95v-81.06h17.95V-424.95z M-290.23-424.95h-20.99l-8.37-30.87h-30.63l-6.73,30.87h-19.63 l30.16-110.03h23.28L-290.23-424.95z M-345.36-472.09h20.97l-10.23-43.19L-345.36-472.09z M-266.77-537.21 c5.99,0,10.86,4.87,10.86,10.86s-4.87,10.86-10.86,10.86c-5.99,0-10.86-4.87-10.86-10.86S-272.76-537.21-266.77-537.21z"
})));

function SvgAi(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 152.5 152.5",
    style: {
      enableBackground: "new 0 0 152.5 152.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.d8b2bc4d.svg";
export { ForwardRef as ReactComponent };